module.exports = __webpack_public_path__ + "img/washinglogo.7be764d1.png";